import { createFilterOptions } from "@mui/material/Autocomplete";

export const getShareRecipientSearchText = (user = {}) => (
  [user.displayName, user.firstName, user.lastName, user.email]
    .filter(Boolean)
    .join(' ')
);

export const shareRecipientFilterOptions = createFilterOptions({
  stringify: getShareRecipientSearchText,
});
